import { Img } from "components";
import { useGlobalState } from "components/GlobalState";
import { useRef, useState } from "react";
import { insertLanguageInUrl } from "utils";

interface VideoProps {
  videoLinks: any;
  dynamicVideoLink?: string;
  videoLoader?: string;
  handleDynamicVideoLink?: any;
  videoRef?: any;
  handleOnPalyAndEnd?: any;
  dontPlayMainVideoOnEveryRender?: boolean;
}

const AvatarVideo = ({
  videoLinks,
  dynamicVideoLink,
  handleDynamicVideoLink,
  videoLoader,
  videoRef,
  dontPlayMainVideoOnEveryRender,
  handleOnPalyAndEnd,
}: VideoProps) => {
  const {
    isMuted,
    setIsMuted,
    videoReplayOnPageLoad,
    setVideoReplayOnPageLoad,
    language,
  } = useGlobalState();

  const [videoLoading, setVideoLoading] = useState(false);
  const [currentVideoPosition, setCurrentVideoPosition] = useState(0);
  const localVideoRef = useRef<HTMLVideoElement>(null);

  const finalVideoRef = videoRef || localVideoRef;

  const fetchVideo = () => {
    return (
      dynamicVideoLink ||
      videoLinks?.[currentVideoPosition]?.url ||
      videoLinks?.at(-1)?.url
    );
  };

  const handleVideoLoader = (booleanValue: boolean) => {
    setVideoLoading(booleanValue);
  };

  const toggleMute = () => {
    setIsMuted((prev) => !prev);
  };

  // const onPlay = () => {
  //     if(!!handleOnPalyAndEnd && fetchVideo()?.includes("comm-demo-end.mp4")) {
  //         handleOnPalyAndEnd(true)
  //     }
  // }

  const handleEnded = () => {
    if (dontPlayMainVideoOnEveryRender) {
      setVideoReplayOnPageLoad([
        ...videoReplayOnPageLoad,
        window.location.pathname,
      ]);
    }
    if (+currentVideoPosition < videoLinks?.length - 1) {
      setCurrentVideoPosition((pos) => +pos + 1);
    } else {
      setCurrentVideoPosition(undefined);
    }
    // if(!!handleOnPalyAndEnd && fetchVideo()?.includes("comm-demo-end.mp4")) {
    //     handleOnPalyAndEnd(false)
    // }
  };

  const handleReplay = () => {
    if (finalVideoRef.current) {
      finalVideoRef.current.currentTime = 0;
      finalVideoRef.current.play();
    }
  };

  const autoPlay = Boolean(
    String(videoLinks?.[0]?.url) === String(fetchVideo()) &&
      videoReplayOnPageLoad?.includes(window.location.pathname)
  )
    ? false
    : true;

  return (
    <div className="relative shadow-2xl shadow-[gray] rounded-lg">
      <div className="relative w-[18vh] h-[18vh] rounded-lg overflow-hidden">
        {videoLoading && (
          <img
            src={videoLoader || "/images/soomuch-demo/VideoLoader.png"}
            className="w-full h-full object-cover object-top"
            // enableShimmer={false}
          />
        )}
        <video
          ref={finalVideoRef}
          src={insertLanguageInUrl(fetchVideo(), language)}
          muted={isMuted}
          autoPlay={autoPlay}
          onEnded={handleEnded}
          playsInline
          disablePictureInPicture
          controlsList="nodownload nofullscreen noplaybackrate noremoteplayback"
          onLoadStart={() => handleVideoLoader(true)}
          onLoadedData={() => handleVideoLoader(false)}
          onError={() => handleVideoLoader(true)}
          className="w-full h-full object-cover object-top"
        />
      </div>

      <button
        onClick={toggleMute}
        className={`absolute bottom-1 right-1 bg-[white] bg-opacity-90 text-white rounded-full p-1`}
        aria-label={isMuted ? "Unmute" : "Mute"}
      >
        {!isMuted ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M9.383 3.076A1 1 0 0110 4v12a1 1 0 01-1.707.707L4.586 13H2a1 1 0 01-1-1V8a1 1 0 011-1h2.586l3.707-3.707a1 1 0 011.09-.217zM14.657 2.929a1 1 0 011.414 0A9.972 9.972 0 0119 10a9.972 9.972 0 01-2.929 7.071 1 1 0 01-1.414-1.414A7.971 7.971 0 0017 10c0-2.21-.894-4.208-2.343-5.657a1 1 0 010-1.414zm-2.829 2.828a1 1 0 011.415 0A5.983 5.983 0 0115 10a5.984 5.984 0 01-1.757 4.243 1 1 0 01-1.415-1.415A3.984 3.984 0 0013 10a3.983 3.983 0 00-1.172-2.828a1 1 0 010-1.415z"
              clipRule="evenodd"
            />
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M9.383 3.076A1 1 0 0110 4v12a1 1 0 01-1.707.707L4.586 13H2a1 1 0 01-1-1V8a1 1 0 011-1h2.586l3.707-3.707a1 1 0 011.09-.217zM12.293 7.293a1 1 0 011.414 0L15 8.586l1.293-1.293a1 1 0 111.414 1.414L16.414 10l1.293 1.293a1 1 0 01-1.414 1.414L15 11.414l-1.293 1.293a1 1 0 01-1.414-1.414L13.586 10l-1.293-1.293a1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>
        )}
      </button>
      <button
        onClick={handleReplay}
        className="absolute bottom-1 left-1 bg-[white] bg-opacity-90 text-black rounded-full p-1"
        aria-label="Replay"
      >
        <img src={"/images/soomuch-demo/Replay.svg"} className="h-5 w-5" />
      </button>
    </div>
  );
};

export default AvatarVideo;
